import { accordionAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

import { focusRing } from "theme/tokens/accessibility";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(accordionAnatomy.keys);

const baseStyleContainer = defineStyle({
  borderTopWidth: "1px",
  borderColor: "border.divider",
  _first: {
    borderTopWidth: "0",
  },
  _last: {
    borderBottomWidth: "0",
  },
});

const baseStyleButton = defineStyle({
  _focus: {
    boxShadow: "none",
  },
  _focusVisible: {
    ...focusRing,
  },
  _hover: {
    bg: "transparent",
  },
  _disabled: {
    opacity: 1,
    color: "fg.subtle",
    cursor: "default",
  },
  px: "0",
  py: "4",
  textStyle: "base",
});

const baseStylePanel = defineStyle({
  pt: "0",
  px: "0",
  pb: "4",
  textStyle: "caption",
});

const baseStyle = definePartsStyle({
  container: baseStyleContainer,
  button: baseStyleButton,
  panel: baseStylePanel,
});

export const Accordion = defineMultiStyleConfig({ baseStyle });
